module.exports = __webpack_public_path__ + "footable.f6c396c95866da7ecdd6.svg";


//////////////////
// WEBPACK FOOTER
// /app/vendor/footable/fonts/footable.svg
// module id = ../../../../../vendor/footable/fonts/footable.svg
// module chunks = styles